import { render, staticRenderFns } from "./travelSpecsList.vue?vue&type=template&id=5bfaf7e3&scoped=true&"
import script from "./travelSpecsList.vue?vue&type=script&lang=js&"
export * from "./travelSpecsList.vue?vue&type=script&lang=js&"
import style0 from "./travelSpecsList.vue?vue&type=style&index=0&id=5bfaf7e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfaf7e3",
  null
  
)

export default component.exports